/**
 * Decode a base64url string (the VAPID public key) into the Uint8Array that
 * PushManager.subscribe wants for `applicationServerKey`. base64url uses
 * `-`/`_` and drops padding, so restore both before atob.
 */
export function urlBase64ToUint8Array(base64url: string): Uint8Array<ArrayBuffer> {
  const padding = '='.repeat((4 - (base64url.length % 4)) % 4);
  const base64 = (base64url + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = atob(base64);
  const out = new Uint8Array(new ArrayBuffer(raw.length));
  for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i);
  return out;
}
